"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLovableExtrasDto = instanceOfLovableExtrasDto;
exports.LovableExtrasDtoFromJSON = LovableExtrasDtoFromJSON;
exports.LovableExtrasDtoFromJSONTyped = LovableExtrasDtoFromJSONTyped;
exports.LovableExtrasDtoToJSON = LovableExtrasDtoToJSON;
exports.LovableExtrasDtoToJSONTyped = LovableExtrasDtoToJSONTyped;
var ValuationEstimateDto_1 = require("./ValuationEstimateDto");
var SuburbPerformanceDto_1 = require("./SuburbPerformanceDto");
var RefinedAnalysisDto_1 = require("./RefinedAnalysisDto");
var RoomUpgradesDto_1 = require("./RoomUpgradesDto");
var ComparableSaleDto_1 = require("./ComparableSaleDto");
/**
 * Check if a given object implements the LovableExtrasDto interface.
 */
function instanceOfLovableExtrasDto(value) {
    return true;
}
function LovableExtrasDtoFromJSON(json) {
    return LovableExtrasDtoFromJSONTyped(json, false);
}
function LovableExtrasDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'valuationEstimate': json['valuationEstimate'] == null ? undefined : (0, ValuationEstimateDto_1.ValuationEstimateDtoFromJSON)(json['valuationEstimate']),
        'comparableSales': json['comparableSales'] == null ? undefined : (json['comparableSales'].map(ComparableSaleDto_1.ComparableSaleDtoFromJSON)),
        'refinedAnalysis': json['refinedAnalysis'] == null ? undefined : (0, RefinedAnalysisDto_1.RefinedAnalysisDtoFromJSON)(json['refinedAnalysis']),
        'suburbPerformance': json['suburbPerformance'] == null ? undefined : (0, SuburbPerformanceDto_1.SuburbPerformanceDtoFromJSON)(json['suburbPerformance']),
        'roomUpgrades': json['roomUpgrades'] == null ? undefined : (json['roomUpgrades'].map(RoomUpgradesDto_1.RoomUpgradesDtoFromJSON)),
    };
}
function LovableExtrasDtoToJSON(json) {
    return LovableExtrasDtoToJSONTyped(json, false);
}
function LovableExtrasDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'valuationEstimate': (0, ValuationEstimateDto_1.ValuationEstimateDtoToJSON)(value['valuationEstimate']),
        'comparableSales': value['comparableSales'] == null ? undefined : (value['comparableSales'].map(ComparableSaleDto_1.ComparableSaleDtoToJSON)),
        'refinedAnalysis': (0, RefinedAnalysisDto_1.RefinedAnalysisDtoToJSON)(value['refinedAnalysis']),
        'suburbPerformance': (0, SuburbPerformanceDto_1.SuburbPerformanceDtoToJSON)(value['suburbPerformance']),
        'roomUpgrades': value['roomUpgrades'] == null ? undefined : (value['roomUpgrades'].map(RoomUpgradesDto_1.RoomUpgradesDtoToJSON)),
    };
}
